import { FieldWrapper, Label, NumberInput } from '@commenda/kakashi';
import React from 'react';
import {
  EventHandlerScheduleType,
  TEventHandlerScheduleDefinition,
} from '@commenda/types';
import { MS_PER_DAY, parseMsToTimeUnits, timeUnitsToMs, TTimeUnits } from './duration';

export const DEFAULT_EVENT_HANDLER_SCHEDULE: TEventHandlerScheduleDefinition = {
  scheduleType: EventHandlerScheduleType.AFTER,
  durationMs: MS_PER_DAY,
};

type TScheduleEditorProps = {
  value: TEventHandlerScheduleDefinition;
  onChange: (schedule: TEventHandlerScheduleDefinition) => void;
};

const SCHEDULE_EDITORS: Record<
  EventHandlerScheduleType,
  React.ComponentType<TScheduleEditorProps>
> = {
  [EventHandlerScheduleType.AFTER]: ({ value, onChange }) => {
    const delay = parseMsToTimeUnits(value.durationMs);
    const setDelay = (updates: Partial<TTimeUnits>) => {
      onChange({
        scheduleType: EventHandlerScheduleType.AFTER,
        durationMs: timeUnitsToMs({ ...delay, ...updates }),
      });
    };

    return (
      <FieldWrapper>
        <Label>After</Label>
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-1">
            <NumberInput
              value={delay.days}
              onChange={(v) => setDelay({ days: v ?? 0 })}
              min={0}
              className="w-12 text-center"
              placeholder="0"
            />
            <span className="text-text-secondary txt-small-regular">d</span>
          </div>
          <div className="flex items-center gap-1">
            <NumberInput
              value={delay.hours}
              onChange={(v) => setDelay({ hours: v ?? 0 })}
              min={0}
              max={23}
              className="w-16 text-center"
              placeholder="0"
            />
            <span className="text-text-secondary txt-small-regular">h</span>
          </div>
          <div className="flex items-center gap-1">
            <NumberInput
              value={delay.minutes}
              onChange={(v) => setDelay({ minutes: v ?? 0 })}
              min={0}
              max={59}
              className="w-16 text-center"
              placeholder="0"
            />
            <span className="text-text-secondary txt-small-regular">m</span>
          </div>
        </div>
      </FieldWrapper>
    );
  },
};

export const EventHandlerScheduleEditor = ({
  value,
  onChange,
}: TScheduleEditorProps) => {
  const Editor = SCHEDULE_EDITORS[value.scheduleType];
  if (!Editor) return null;
  return <Editor value={value} onChange={onChange} />;
};
